export default __webpack_public_path__ + "static/media/lr pic 2.ea540340.svg";